import React, { useState } from 'react'
import styled, { keyframes } from 'styled-components'
import { Location } from '@reach/router'
import { useIntl } from 'gatsby-plugin-intl'
import routes from 'src/utils/routes'
import LogoUrl from 'src/assets/logo-gray.png'

import { useSiteMetadata } from 'src/hooks/useSiteMetadata'
import { LoaderStyled } from 'src/components/header/HeaderLoggedIn'
import { connectGlobalLoader } from 'src/ducks/connectors'
import {
  LogoWrapper,
  Logo,
  NavigationList,
  NavigationElement,
  NavigationLink,
  Burger,
  BurgerWrapper,
  MobileNavWrapper
} from './components/atoms'
import Drawer from './components/Drawer'

const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.4; }
`

const DemoBadge = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px;
  border-radius: 4px;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #b8860b;
  background: rgba(255, 193, 7, 0.12);
  border: 1px solid rgba(255, 193, 7, 0.35);
  white-space: nowrap;
  margin-left: 12px;
  user-select: none;
  cursor: default;
  transition: all 0.2s ease;
  &:hover {
    background: rgba(255, 193, 7, 0.2);
    border-color: rgba(255, 193, 7, 0.5);
  }
`

const DemoBadgeDot = styled.span`
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: #f0ad4e;
  animation: ${pulse} 1.5s ease-in-out infinite;
`

const Header = ({ className, isGlobalLoaderLoading }) => {
  const intl = useIntl()
  const [drawerOpen, setOpen] = useState(false)
  const isDemoMode = process.env.GATSBY_DEMO === 'true'

  const {
    navigation: {
      main: { links }
    }
  } = useSiteMetadata()

  const mainWebsiteUrl =
    process.env.GATSBY_MAIN_WEBSITE_URL || 'https://e-containers.eu'

  return (
    <Location>
      {({ location: { pathname } }) => (
        <>
          <nav className={className}>
            <LoaderStyled loading={isGlobalLoaderLoading} />
            <LogoWrapper to='https://e-containers.eu'>
              <a href={`${mainWebsiteUrl}/${intl.locale}`}>
                <Logo src={LogoUrl} alt='logo' />
              </a>
            </LogoWrapper>
            <NavigationList>
              {/* <EuFinancingLogoSmall /> */}

              {isDemoMode && (
                <NavigationElement>
                  <DemoBadge>
                    <DemoBadgeDot />
                    {intl.formatMessage({ id: 'common.thisIsADemoVersion' })}
                  </DemoBadge>
                </NavigationElement>
              )}

              {links.map((link, index) => {
                {
                  /* exclude jobs from non polish pages */
                }
                if (link.name == 'jobs' && intl.locale !== 'pl') {
                  return null
                }
                return (
                  <NavigationElement key={index}>
                    <NavigationLink
                      to={link.path}
                      active={pathname.includes(link.path)}
                      accent={link.path === routes.SIGN_IN}
                    >
                      {intl.formatMessage({ id: `navigation.${link.name}` })}
                    </NavigationLink>
                  </NavigationElement>
                )
              })}
            </NavigationList>
            <BurgerWrapper>
              <Burger onClick={() => setOpen(!drawerOpen)} />
            </BurgerWrapper>
          </nav>
          <Drawer open={drawerOpen} onClose={() => setOpen(false)}>
            <MobileNavWrapper>
              {isDemoMode && (
                <NavigationElement
                  style={{ paddingLeft: '0.8rem', justifyContent: 'center' }}
                >
                  <DemoBadge style={{ margin: '0.6rem 0' }}>
                    <DemoBadgeDot />
                    {intl.formatMessage({ id: 'common.thisIsADemoVersion' })}
                  </DemoBadge>
                </NavigationElement>
              )}
              {links.map((link, index) => (
                <NavigationElement key={index}>
                  <NavigationLink
                    to={link.path}
                    onClick={() => setOpen(false)}
                    active={pathname.includes(link.path)}
                    accent={link.path === routes.SIGN_IN}
                  >
                    {intl.formatMessage({ id: `navigation.${link.name}` })}
                  </NavigationLink>
                </NavigationElement>
              ))}
            </MobileNavWrapper>
          </Drawer>
        </>
      )}
    </Location>
  )
}

const connectedComponent = connectGlobalLoader(Header)

export default styled(connectedComponent)`
  display: flex;
  height: ${({ theme }) => theme.dimensions.topBarHeight};
  flex-direction: row;
  justify-content: space-between;
  position: relative;
  z-index: 100;
  width: 100%;
  background-color: white;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
`
